import { mbSocialSharing, socialSharing } from "../../common/sharing.js";
import { formAddCsrfProtection } from "../../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	window.globalLoginWindowHandler.pollLogin(
		document.querySelectorAll("._submit_survey_form"),
	);

	for (const el of document.querySelectorAll("._submit_survey_form")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			const form = event.currentTarget.closest("form");
			formAddCsrfProtection(form).then((data) => {
				form.submit();
			});
		});
	}

	if (document.querySelector("#social-share")) {
		// SOCIAL SHARE
		const x_text = document.querySelector("#social-share .X").dataset.text;
		const fb = new socialSharing(
			document.querySelector("#social-share .facebook"),
			{ kind: "facebook" },
		);
		const x = new socialSharing(document.querySelector("#social-share .X"), {
			kind: "x",
			title: x_text,
			suffix: " via @Multiplayerit",
		});
		const tg = new socialSharing(
			document.querySelector("#social-share .telegram"),
			{ kind: "telegram" },
		);
		const wa = new socialSharing(
			document.querySelector("#social-share .whatsapp"),
			{ kind: "whatsapp" },
		);
	}
	const mb_share = document.querySelector("#_share-mb");
	if (mb_share) {
		mb_share.addEventListener("click", (event) => {
			event.preventDefault();
			mbSocialSharing(mb_share);
		});
	}
});
